import { fetchForm, fetchFormSections } from "@/api/forms";
import type { FormDto } from "@/types/form";
import { isYandexForm } from "@/lib/forms/formSource";
import { mergeFormSections } from "@/lib/forms/resolveFormSections";

export async function loadFormForEdit(formId: number): Promise<FormDto> {
  const form = await fetchForm(formId);

  if (isYandexForm(form)) {
    return {
      ...form,
      sections: mergeFormSections(form, []),
    };
  }

  const sections = await fetchFormSections(formId);

  return {
    ...form,
    sections: mergeFormSections(form, sections),
  };
}
